<template>
  <div class="content">
    <blue-title>{{ title }}</blue-title>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'detailContent',
  props: {
    title: String,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

.content {
  flex: 1;
  background-color: @bg-white;
  padding: 25px 0 48px 0;
  .h4 {
    margin: 0;
    margin-left: 20px;
    height: 18px;
    font-size: 16px;
    color: #333333;
    .flex_layout(row, flex-start);
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 100%;
      margin-right: 0.5em;
      background-color: @primary-blue;
    }
  }
}
</style>
